var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.552 15.712C14.096 15.712 13.736 16.112 13.736 16.6C13.736 17.088 14.104 17.488 14.552 17.488C15.008 17.488 15.368 17.088 15.368 16.6C15.376 16.112 15.008 15.712 14.552 15.712ZM17.472 15.712C17.016 15.712 16.656 16.112 16.656 16.6C16.656 17.088 17.024 17.488 17.472 17.488C17.928 17.488 18.288 17.088 18.288 16.6C18.288 16.112 17.928 15.712 17.472 15.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.36 9H10.64C9.736 9 9 9.736 9 10.648V21.464C9 22.376 9.736 23.112 10.64 23.112H19.712L19.288 21.632L20.312 22.584L21.28 23.48L23 25V10.648C23 9.736 22.264 9 21.36 9ZM18.272 19.448C18.272 19.448 17.984 19.104 17.744 18.8C18.792 18.504 19.192 17.848 19.192 17.848C18.864 18.064 18.552 18.216 18.272 18.32C17.872 18.488 17.488 18.6 17.112 18.664C16.344 18.808 15.64 18.768 15.04 18.656C14.584 18.568 14.192 18.44 13.864 18.312C13.68 18.24 13.48 18.152 13.28 18.04C13.256 18.024 13.232 18.016 13.208 18C13.192 17.992 13.184 17.984 13.176 17.976C13.032 17.896 12.952 17.84 12.952 17.84C12.952 17.84 13.336 18.48 14.352 18.784C14.112 19.088 13.816 19.448 13.816 19.448C12.048 19.392 11.376 18.232 11.376 18.232C11.376 15.656 12.528 13.568 12.528 13.568C13.68 12.704 14.776 12.728 14.776 12.728L14.856 12.824C13.416 13.24 12.752 13.872 12.752 13.872C12.752 13.872 12.928 13.776 13.224 13.64C14.08 13.264 14.76 13.16 15.04 13.136C15.088 13.128 15.128 13.12 15.176 13.12C15.664 13.056 16.216 13.04 16.792 13.104C17.552 13.192 18.368 13.416 19.2 13.872C19.2 13.872 18.568 13.272 17.208 12.856L17.32 12.728C17.32 12.728 18.416 12.704 19.568 13.568C19.568 13.568 20.72 15.656 20.72 18.232C20.72 18.232 20.04 19.392 18.272 19.448Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.f546140172c55e1e2481870065b74b4b.svg";
export { ForwardRef as ReactComponent };